
import { defineComponent, SetupContext, computed, ref } from "vue";
import NativeClient from "@/client/native-client";
import PantryLoadingPullToRefresh from "@/components/common/PantryLoadingPullToRefresh.vue";

export default defineComponent({
  name: "PantryPullToRefresh",
  components: { PantryLoadingPullToRefresh },
  props: {
    /** トップマージン 単位はrem */
    topMargin: {
      type: Number,
      default: 0
    },
    enabled: {
      type: Boolean,
      default: true,
      required: true
    },
    topClass: {
      type: String,
      default: "pantry-pull-to-refresh",
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const topClass = props && props.topClass ? props.topClass : "pantry-pull-to-refresh";
    const indicatorThreshold = 60;
    const refreshThreshold = 300;
    const styleTop = computed(() => {
      return { 'padding-top': `${props.topMargin}rem` };
    });
    const topLoadingPosition = 0;
    let touchStartPosition = 0;
    let isRefreshing = false;
    let isRefreshingDisplay = false;
    const refPullToRefresh = ref(false);
    const processPullToRefresh = (isRefreshing: boolean) => {
      refPullToRefresh.value = isRefreshing;
      if (isRefreshing) {
        NativeClient.sendDebugLog("PantryPullToRefresh detect refresh");
      }
    };
    const touchStart = (event: TouchEvent) => {
      NativeClient.sendDebugLog("PantryPullToRefresh touchStart");
      if (props.enabled) {
        touchStartPosition = event.touches[0].pageY;
      }
    };
    const touchMove = (event: TouchEvent) => {
      NativeClient.sendDebugLog("PantryPullToRefresh touchMove touchStartPosition=" + touchStartPosition);
      if (!props.enabled) {
        return;
      }
      const currentY = event.touches[0].pageY;
      let targetElement = document.elementFromPoint(event.touches[0].pageX, event.touches[0].pageY);
      while (targetElement != null && targetElement!.className != "pantry-pull-to-refresh") {
        if (targetElement != null && targetElement!.className == topClass) {
          if (targetElement != null) {
            NativeClient.sendDebugLog("PantryPullToRefresh targetElement!.scrollTop=" + targetElement!.scrollTop);
          }
          break;
        }
        targetElement = targetElement.parentElement;
      }
      if (targetElement == null || isRefreshing == true) {
        NativeClient.sendDebugLog("PantryPullToRefresh moveEvent no target or already refreshing");
        return;
      }
       NativeClient.sendDebugLog("PantryPullToRefresh currentY=" + currentY);
      if (targetElement!.scrollTop <= 0) {
        const currentDifference = currentY - touchStartPosition;
        let actualRefreshThreshold = refreshThreshold;
        if (NativeClient.isIOS()) {
          // iOSならば1/3にする（調整結果）
          actualRefreshThreshold = actualRefreshThreshold / 3;
          NativeClient.sendDebugLog("PantryPullToRefresh moveEvent iOS");
        }
        if (actualRefreshThreshold < currentDifference) {
          NativeClient.sendDebugLog("PantryPullToRefresh moveEvent refreshing start");
          isRefreshing = true;
          context.emit("refresh");
          window.setTimeout(() => {
            processPullToRefresh(false);
          }, 200);
        } else if (indicatorThreshold < currentDifference && !isRefreshingDisplay) {
          NativeClient.sendDebugLog("PantryPullToRefresh moveEvent refreshing display start");
          isRefreshingDisplay = true;
          processPullToRefresh(true);
        }
      }
    };
    const touchEnd = () => {
      NativeClient.sendDebugLog("PantryPullToRefresh touchEnd");
      isRefreshing = false;
      isRefreshingDisplay = false;
      processPullToRefresh(false);
    };
    const showPullToRefresh = computed(() => {
      if (refPullToRefresh.value) {
        return true;
      }
      return false;
    });

    return {
      styleTop,
      touchStart,
      touchMove,
      touchEnd,
      showPullToRefresh,
      topLoadingPosition
    };
  }
});
